import React from 'react';
import { Radio } from "@mui/material"

const StyledRadio: React.FC<React.ComponentProps<typeof Radio>> = (props) => {
    return <Radio {...props} sx={{
        ...props.sx,
        color: 'silver',
        '&.Mui-checked': {
            color: '#FFB01D',
        },
    }} />
}

export default StyledRadio;